export default __webpack_public_path__ + "static/media/5.3e8ec1e1.jpg";